/** Registers the LineEdit parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseLineEdit } from './parser';
const lineEditRegistration = {
    typeName: 'LineEdit',
    parser: parseLineEdit,
};
nodeRegistry.register(lineEditRegistration);
export * from './parser';
export * from './displayText';
export * from './types';
//# sourceMappingURL=index.js.map